import { Pipe, PipeTransform, inject } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { SupervisorTypeEnum } from '../models/enums/supervisor-type.enum';

@Pipe({
  name: 'translateSupervisorType',
  standalone: false
})
export class TranslateSupervisorTypePipe implements PipeTransform {
  private translateService = inject(TranslateService);

  private map = new Map<SupervisorTypeEnum, string>([
    [SupervisorTypeEnum.Direct, 'Direct'],
    [SupervisorTypeEnum.Temporary, 'Temporary'],
  ]);

  constructor() { }
  transform(value: SupervisorTypeEnum): string {
    return this.translateService.instant(this.map.get(value));
  }
}
